import Colaborador from '../Colaborador'
import './time.css'

const Time = ({ time, colaboradores, aoDeletar, mudarCor, aoFavoritar}) => {
    return (
        colaboradores.length > 0 && <section className='time' style={{ backgroundImage: 'url(/imagens/fundo.png)', backgroundColor: time.cor}}>
            <input onChange={evento => mudarCor(evento.target.value, time.id)} type="color" className='input-cor' value={time.cor}/>

            <h3 style={{ borderColor: time.cor }}>{time.nome}</h3>
            <div className='colaboradores'>
                {colaboradores.map((colaborador, indice) => {
                     return (
                     <Colaborador 
                     key={indice} 
                     colaborador={colaborador} corDeFundo={time.cor} 
                     aoDeletar={aoDeletar} 
                     aoFavoritar={aoFavoritar}
                     />
                )
                })}
            </div>
        </section>
    )
}

export default Time